import { useAuth } from "@project/contexts/AuthContext";
import Dashboard from "@project/pages/Dashboard";
import InterviewerDashboard from "@project/pages/InterviewerDashboard";
import CandidateDashboard from "@project/pages/CandidateDashboard";

export function RoleDashboard() {
  const { user } = useAuth();

  switch (user?.role) {
    case "interviewer":
      return <InterviewerDashboard />;
    case "candidate":
      return <CandidateDashboard />;
    default: // admin, hr
      return <Dashboard />;
  }
}
